/**
 * Where a lesson should start when it is opened.
 *
 * The server stores the last reported playhead (`course_lesson_progress.
 * position_seconds`); this decides whether honouring it actually helps. A
 * position parked in the final seconds is not a resume point — it is the credits
 * — and dropping the learner there would make a finished lesson look broken.
 */
export const RESUME_END_GRACE_SECONDS = 5;

export function resolveResumePosition({
  serverPosition,
  duration,
  completedAt,
}: {
  serverPosition: number | null | undefined;
  duration: number | null | undefined;
  completedAt?: string | null;
}): number {
  const position = serverPosition ?? 0;
  if (!Number.isFinite(position) || position <= 0) return 0;
  if (duration != null && Number.isFinite(duration) && duration > 0) {
    // Within the grace window of the end — or a lesson already marked complete
    // that was watched to the end — starts over.
    if (position >= duration - RESUME_END_GRACE_SECONDS) return 0;
    if (completedAt && position >= duration - RESUME_END_GRACE_SECONDS) return 0;
    return Math.min(position, duration - 1);
  }
  return position;
}

/** Below this the jump is too small to be worth telling the learner about. */
export function shouldAnnounceResume(position: number): boolean {
  return position > RESUME_END_GRACE_SECONDS;
}
